import React from 'react';
import PropTypes from 'prop-types';
import ColorPicker from 'components/colorPicker/color-picker';
import {
  Checkbox, Form, Input, Tag
} from 'antd';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const { is_workable, color, name } = dataSource;

  return {
    is_workable: Form.createFormField({ value: is_workable }),
    color: Form.createFormField({ value: color }),
    name: Form.createFormField({ value: name })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, checkboxFormItemLayout, dataSource, inputFormItemLayout, form
}) => {
  const { getFieldDecorator } = form;
  const { is_workable, color, name } = dataSource;
  const readonly = !canAdmin;
  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Name">
        {
          getFieldDecorator('name', {
            initialValue: name,
            rules: [{
              required: true,
              message: 'Please enter the Leg Type name.'
            }]
          })(<Input disabled={readonly} />)
        }
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Colour">
        {!readonly && getFieldDecorator('color', {
          initialValue: color,
          rules: [{
            required: true,
            message: 'Please enter a Colour.'
          }]
        })(<ColorPicker />)}
        {readonly && (
          <Tag color={color}>
            {color}
          </Tag>
        )}
      </FormItem>
      <FormItem {...checkboxFormItemLayout}>
        {
          getFieldDecorator('is_workable', {
            initialValue: is_workable,
            valuePropName: 'checked'
          })(
            <Checkbox disabled={readonly}>
              Is Workable
            </Checkbox>
          )
        }
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func,
  readonly: PropTypes.bool
};

FormInput.defaultProps = {
  canAdmin: false,
  checkboxFormItemLayout: {},
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  onFieldsChange() {
  },
  onValuesChange() {
  },
  readonly: false
};

const LegTypeFormInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(FormInput));

export default LegTypeFormInput;
